import { Box, Flex, HStack, Image, Select, Text, VStack } from '@chakra-ui/react';
import cartP from '../../../assets/cartP.png';
import { deleteIcon, updateIcon } from './Icons';
import { useDispatch } from 'react-redux';
import { remove_from_cart, add_to_cart } from '../../../redux/actions/productActions';
import toast from 'react-hot-toast';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';

const SingleCartItem = ({ item, quoteId, setRefresh, refresh }) => {
    const dispatch = useDispatch();
    const quantity = item?.qty;
    const items = JSON.parse(localStorage.getItem('cart_items'));
    let cart_item = items ? items?.filter((cart_item) => cart_item?.sku === item.sku) : [];

    const updateCartItems = () => {
        if (quantity) {
            let data = {
                sku: item?.sku,
                quoteId,
                qty: quantity,
            };

            toast.promise(
                dispatch(add_to_cart(data)),
                {
                    loading: 'Updating...',
                    success: <b> Item updated</b>,
                    error: <b>Could not update item.</b>,
                },
                { position: 'top-right' },
            );
        }
    };

    const deleteFromCart = () => {
        let data = {
            quoteId,
            itemId: item.item_id,
        };
        toast.promise(
            dispatch(remove_from_cart(data)),
            {
                loading: 'Removing...',
                success: <b> Removed from cart</b>,
                error: <b>Could not remove.</b>,
            },
            { position: 'top-right' },
        );
    };

    return (
        <Box w={{ base: '85vw', lg: 'full' }} mx="auto" mt="15px">
            <HStack w="full" justifyContent="space-between" alignItems="start" mb=".5rem" mt="20px">
                <Box w="70%">
                    <Text fontSize="15px" fontWeight={600}>
                        {item.name}
                    </Text>
                    <Text color="#868E96" fontSize="11px">
                        {item.brandName}
                    </Text>
                </Box>
                <Box textAlign="right">
                    <Text color="#868E96" fontSize="12px" textDecoration="line-through">
                        {item.discount && '₦' + item.discount}
                    </Text>
                    <Text fontSize="18px" fontWeight={600}>
                        {item.price && <WalletHistoryPrice price={item.price * quantity} />}
                    </Text>
                </Box>
            </HStack>
            <HStack w="full" justifyContent="space-between">
                <Image src={cart_item[0]?.image || cartP} w="120px" ml="1rem" />
                <VStack gap="20px">
                    {item.color && (
                        <HStack gap="20px" alignItems="center" justifyContent="space-between">
                            <Text>Color</Text>
                            <Select
                                placeholder={item.color}
                                size="md"
                                fontSize="13px"
                                w="100px"
                                h="36px"
                                textTransform="capitalize"
                            />
                        </HStack>
                    )}
                    {item.size && (
                        <HStack gap="20px" alignItems="center" justifyContent="space-between">
                            <Text>Size</Text>
                            <Select
                                placeholder={item.size}
                                size="md"
                                h="36px"
                                fontSize="13px"
                                w="100px"
                                textTransform="capitalize"
                            />
                        </HStack>
                    )}
                    <HStack gap="20px" alignItems="center" justifyContent="space-between">
                        <Text>Qty</Text>
                        <Text>{item.qty}</Text>
                    </HStack>
                    <Flex gap="20px" justifyContent="flex-end" w="full">
                        <Box cursor="pointer" onClick={updateCartItems}>
                            {updateIcon}
                        </Box>
                        <Box cursor="pointer" onClick={deleteFromCart}>
                            {deleteIcon}
                        </Box>
                    </Flex>
                </VStack>
            </HStack>
        </Box>
    );
};

export default SingleCartItem;
